var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import { FelaComponent } from '@filou/core';
var rule = function (_a) {
    var theme = _a.theme;
    return ({
        '& h5': {
            marginBottom: theme.space1,
            marginTop: 10
        },
        '& label': {
            marginBottom: theme.space1,
            fontSize: '0.87055rem',
            color: theme.light
        },
        '& fieldset': {
            // boxShadow: '0 1px 0 #ebebec',
            border: 0,
            borderRadius: theme.borderRadius,
            paddingY: theme.space1,
            paddingX: 0,
            '> legend': {
                fontSize: '0.87055rem',
                color: theme.light
            },
            '> label': {
                marginRight: theme.space1
            }
        },
        '> fieldset > input': {
            // boxShadow: '0 1px 0 #ebebec',
            borderRadius: theme.borderRadius,
            marginTop: 10,
            width: '100%',
            color: theme.color,
            border: '1px solid lightgray',
            fontSize: theme.fontSize,
            fontFamily: theme.fontFamily,
            fontWeight: theme.fontWeight,
            paddingY: 5,
            marginBottom: 5
        },
        '> fieldset > textarea': {
            // boxShadow: '0 1px 0 #ebebec',
            marginTop: 10,
            fontSize: theme.fontSize,
            color: theme.color,
            borderRadius: theme.borderRadius,
            fontFamily: theme.fontFamily,
            fontWeight: theme.fontWeight,
            width: '100%',
            border: '1px solid lightgray',
            marginBottom: 5
        },
        '> button': {
            backgroundColor: theme.light,
            marginTop: 10,
            paddingX: 20,
            paddingY: 5,
            color: theme.color,
            fontSize: theme.fontSize,
            fontFamily: theme.fontFamily,
            fontWeight: theme.fontWeight,
            lineHeight: '18px',
            // boxShadow: '0 1px 0 #ebebec',
            border: 0,
            borderRadius: theme.borderRadius,
            onHover: {
                backgroundColor: theme.light1
            }
        },
        '> button:disabled': {
            opacity: 0.5
        }
    });
};
var Form = function (_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    return (React.createElement(FelaComponent, { rule: rule, render: function (_a) {
            var className = _a.className;
            return (React.createElement("form", __assign({}, rest, { className: className }), children));
        } }));
};
export default Form;
//# sourceMappingURL=index.js.map